import { render, staticRenderFns } from "./HuaxianProjectDetail.vue?vue&type=template&id=4005013f&scoped=true&"
import script from "./HuaxianProjectDetail.vue?vue&type=script&lang=js&"
export * from "./HuaxianProjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianProjectDetail.vue?vue&type=style&index=0&id=4005013f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4005013f",
  null
  
)

export default component.exports